export class EmployeesQueryFilter {
    searchText: String = '';
    page: any;
    size: any = 9;
    companyId: String;
    constructor(companyId) {
        this.companyId = companyId;
    }
}